module.exports = Jsw.skinUrl + "/icons/16/plesk/top-advisor.svg?0b30181a1696d46d7ee8ab9b6594518b";